/**
 * Slack 아이콘 SVG
 * 고정 SVG 정의
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <SlackIcon className="w-8 h-8" />
 * <SlackIcon className="w-12 h-12" />
 * ```
 */
export function SlackIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-label="Slack icon"
      role="img"
    >
      <title>Slack</title>
      <path
        d="M20.4809 11.192C21.596 11.192 22.5 10.288 22.5 9.17292C22.5 8.05782 21.5959 7.15385 20.4808 7.15385C19.3657 7.15385 18.4615 8.0579 18.4615 9.17308V11.192H20.4809ZM14.8269 11.192C15.9421 11.192 16.8462 10.2879 16.8462 9.17275V3.51923C16.8462 2.40404 15.9421 1.5 14.8269 1.5C13.7117 1.5 12.8077 2.40404 12.8077 3.51923V9.17275C12.8077 10.2879 13.7117 11.192 14.8269 11.192Z"
        fill="#2EB67D"
      />
      <path
        d="M3.51906 12.808C2.40396 12.808 1.5 13.712 1.5 14.8271C1.5 15.9422 2.40405 16.8461 3.51914 16.8461C4.63433 16.8461 5.53846 15.9421 5.53846 14.8269V12.808H3.51906ZM9.17308 12.808C8.0579 12.808 7.15385 13.712 7.15385 14.8272V20.4808C7.15385 21.5959 8.0579 22.5 9.17308 22.5C10.2883 22.5 11.1923 21.5959 11.1923 20.4808V14.8272C11.1923 13.712 10.2883 12.808 9.17308 12.808Z"
        fill="#E01E5A"
      />
      <path
        d="M12.8077 20.4809C12.8077 21.596 13.7117 22.5 14.8268 22.5C15.9419 22.5 16.8458 21.5959 16.8458 20.4808C16.8458 19.3657 15.9418 18.4615 14.8266 18.4615H12.8077V20.4809ZM12.8077 14.8269C12.8077 15.9421 13.7117 16.8462 14.8269 16.8462H20.4804C21.5956 16.8462 22.4997 15.9421 22.4997 14.8269C22.4997 13.7117 21.5956 12.8077 20.4804 12.8077H14.8269C13.7117 12.8077 12.8077 13.7117 12.8077 14.8269Z"
        fill="#ECB22E"
      />
      <path
        d="M11.192 3.51906C11.192 2.40396 10.288 1.5 9.17292 1.5C8.05782 1.5 7.15385 2.40405 7.15385 3.51914C7.15385 4.63434 8.0579 5.53846 9.17308 5.53846H11.192V3.51906ZM11.192 9.17308C11.192 8.0579 10.2879 7.15385 9.17275 7.15385H3.51923C2.40404 7.15385 1.5 8.0579 1.5 9.17308C1.5 10.2883 2.40404 11.1923 3.51923 11.1923H9.17275C10.2879 11.1923 11.192 10.2883 11.192 9.17308Z"
        fill="#36C5F0"
      />
    </svg>
  );
}
